import LegalLayout from '@/components/LegalLayout';

/* Impressum der App. Angaben spiegeln das Impressum von always-on-stock.de. */
export default function Impressum() {
  return (
    <LegalLayout title="Impressum" updated="Juli 2026">
      <h2>Angaben gemäß § 5 DDG</h2>
      <address>
        blitzblank GmbH<br />
        Giesenkamp 110<br />
        59348 Lüdinghausen<br />
        Deutschland
      </address>

      <h2>Vertreten durch</h2>
      <p>Geschäftsführung: Alexander Osius</p>

      <h2>Handelsregister</h2>
      <p>
        Registergericht: Amtsgericht Coesfeld<br />
        Registernummer: HRB 20830
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: 02591 / 2069600<br />
        E-Mail: <a href="mailto:hallo@always-on-stock.de">hallo@always-on-stock.de</a>
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE366757939</p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <address>
        Alexander Osius<br />
        Giesenkamp 110<br />
        59348 Lüdinghausen
      </address>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          https://ec.europa.eu/consumers/odr
        </a>
        . Unsere E-Mail-Adresse findest du oben im Impressum.
      </p>

      <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalLayout>
  );
}
